import type {BetOfferClick, NavigateToEvent} from "@atg-sport-shared/analytics-types";
import {trackSportEvent} from "@atg-sport-shared/analytics";

export const betHistoryShowHorseGamesClick = () => {
    trackSportEvent({
        event: "sportBetHistoryShowHorseGames",
    });
};

export const sportInsufficientBalanceDepositClick = () => {
    trackSportEvent({
        event: "sportInsufficientBalanceDepositClick",
    });
};

export const sportLoginFailed = (reason: string) => {
    trackSportEvent({
        event: "sportLoginFailed",
        reason,
    });
};

export const sportAbortSearch = (press: string, term: string) => {
    trackSportEvent({
        event: "sportAbortSearch",
        press,
        term,
    });
};

export const sportStatsOpen = (
    eventId: number,
    sport: string,
    origin: string,
    targetBlank = false,
) => {
    trackSportEvent({
        event: "sportStatsOpen",
        eventId,
        sport,
        origin,
        targetBlank,
    });
};

export const sportStatsClose = (eventId: number, sport: string, duration: number) => {
    trackSportEvent({
        event: "sportStatsClose",
        eventId,
        sport,
        duration,
    });
};

export type BetOfferClickTrackingParameters = Omit<BetOfferClick, "event">;

export function betOfferClickTracking({
    eventId,
    sport,
    name,
    isLive,
    target,
    betOfferTypeName,
    odds,
    position,
}: BetOfferClickTrackingParameters) {
    const eventData = {
        event: "betOfferClick",
        eventId,
        sport,
        name,
        isLive,
        target,
        odds,
    } as const;

    if (typeof position === "number") {
        Object.assign(eventData, {position});
    }

    if (typeof betOfferTypeName === "string") {
        Object.assign(eventData, {betOfferTypeName});
    }

    trackSportEvent(eventData);
}

export type NavigateToEventTrackingParameters = Omit<NavigateToEvent, "event">;

export function navigateToEventTracking({
    eventId,
    sport,
    name,
    isLive,
    target,
    hasShortInfo,
    position,
}: NavigateToEventTrackingParameters) {
    const eventData = {
        event: "navigateToEvent",
        eventId,
        sport,
        name,
        isLive,
        target,
    } as const;

    if (typeof position === "number") {
        Object.assign(eventData, {position});
    }

    if (typeof hasShortInfo === "boolean") {
        Object.assign(eventData, {hasShortInfo});
    }

    trackSportEvent(eventData);
}

export const sportNavigateError = (path: string, error: string) => {
    trackSportEvent({event: "sportNavigateError", path, error});
};
